import React from "react";
import PropTypes from "prop-types";
import {
  FixedWidth,
  PagesHeading,
  DataValueColorNavy
} from "../../commonStyles";
import { ContentMessage, Types } from "../../ContentMessages";

export default function DashboardSummary(props) {
  const { accData } = props;
  return (
    <FixedWidth data-test='dashBoardSummary'>
      <PagesHeading>
        <ContentMessage
          type={[Types.PAGE_TITLE_DESCRIPTION]}
          page="Investment Dashboard"
          property="field_page_title"
          defaultMessage="Investment Overview"
          setTitle={title =>
            props.setPageTitle ? props.setPageTitle(title) : null
          }
        />
      </PagesHeading>
      <DataValueColorNavy isBreak className="mt-10">
        {accData.accountName} - {accData.accountId}
      </DataValueColorNavy>
    </FixedWidth>
  );
}

DashboardSummary.propTypes = {
  accData: PropTypes.object,
  setPageTitle: PropTypes.func
};
